
import { supabase } from '@/lib/supabase'

/**
 * Met à jour l'abonnement d'une organisation
 */
export async function updateOrganizationSubscription(orgId: string, subscription_plan_id: string) {
  console.log('Mise à jour du subscription_plan_id via RPC...');
  try {
    const { error: updateError } = await supabase.rpc(
      'update_organization_subscription',
      { 
        p_organization_id: orgId,
        p_subscription_plan_id: subscription_plan_id
      }
    );
      
    if (updateError) {
      console.error('Erreur lors de la mise à jour du subscription_plan_id via RPC:', updateError);
      
      // Fallback to direct update
      console.log('Tentative de mise à jour directe du subscription_plan_id');
      const { error: directUpdateError } = await supabase
        .from('organizations')
        .update({ subscription_plan_id: subscription_plan_id })
        .eq('id', orgId);
        
      if (directUpdateError) {
        console.error('Échec de la mise à jour directe du subscription_plan_id:', directUpdateError);
      } else {
        console.log('subscription_plan_id mis à jour avec succès via mise à jour directe');
      }
    } else {
      console.log('subscription_plan_id mis à jour avec succès via RPC');
    }
  } catch (error) {
    console.error('Exception lors de la mise à jour de l\'abonnement:', error);
  }
}
